import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'loyaltic-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() hideNav = false;
  isCollapsed = false;
  isLoggedIn = false;
  userId: any;
  currentPage="";
  isOnLandingPage = false;
  lotteryModalRef: BsModalRef;

  @ViewChild('lotteryModal', { static: false }) lotteryModal: any;

  constructor(private authService: AuthService, private router: Router, private modalService: BsModalService) { 
    this.userId = authService.getUserId();
    this.isLoggedIn = authService.IsLoggedIn();

    this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          this.currentPage = this.router.url;
          this.isOnLandingPage = this.getPath(this.currentPage) === '/';
          this.isCollapsed = false;
          //console.log('this.router.url', this.router.url);
        }
      }
    );
  }

  ngOnInit() {
    this.currentPage = this.router.url;
    this.isOnLandingPage = this.getPath(this.currentPage) === '/';
    //console.log(this.currentPage);

    this.authService.loginEmitter.subscribe((response: boolean) => {
      this.isLoggedIn = response;
    });
  }

  onLogoutClick() {
    this.isLoggedIn = false;
    this.authService.resetTokens();
    this.router.navigate(['/']);
  }

  openLotteryModal(event: Event) {
    event.preventDefault();
    this.isCollapsed = false;
    this.lotteryModalRef = this.modalService.show(this.lotteryModal, {
      class: 'modal-dialog-centered modal-order'
    });
  }

  private getPath(url: string): string {
    return (url || '').split('?')[0].split('#')[0];
  }

}
